import {
  faCcVisa,
  faCcMastercard,
  faCcDiscover,
  faCcAmex,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactElement } from 'react';
import './MarketplaceFooter.scss';
import { Link } from 'react-router-dom';
import { getMarketContent } from 'utils/marketContent';
import parse from 'html-react-parser';
import NewsletterSubscription from './NewsletterSubscription';
import SocialIcons from './SocialIcons';

export default function MarketplaceFooter(): ReactElement {
  const market = getMarketContent();
  const data = market.footer;
  const footerCol = market.footer.column;
  const dataCR = market.copyright;
  return (
    <>
      <footer id="marketplace-footer">
        <div className="container px-4 xl:px-0">
          <div className="grid px-2 xl:px-0">
            {footerCol.map(col => (
              <div
                key={col.columnClasses.length * Math.random()}
                className={col.columnClasses}
              >
                {col.columnHeader && (
                  <p className="title">{col.columnHeader}</p>
                )}
                {col.footerHTMLText && (
                  <p className="mb-0">{col.footerHTMLText}</p>
                )}
                {col.footerNavigation && (
                  <ul>
                    {col.footerNavigation.map(linkItem => (
                      <li key={linkItem.url.length * Math.random()}>
                        <Link to={linkItem.url}>{linkItem.label}</Link>
                      </li>
                    ))}
                  </ul>
                )}
                {col.socialLinks.facebook.length > 0 && (
                  <SocialIcons
                    className="marketplace-footer__social-links "
                    socialLinks={col?.socialLinks}
                  />
                )}
              </div>
            ))}
            {data.displayNewsletter && <NewsletterSubscription disableForm />}
          </div>
        </div>
      </footer>
      <div id="bottom-footer">
        <div className="container px-4 xl:px-0">
          <div className="grid align-items-center">
            <div className="col-12 md:col-8 bottom-footer-links text-center md:text-left">
              <ul>
                {dataCR.secondaryLinks.map(linkItem => (
                  <li key={linkItem.url.length * Math.random()}>
                    <Link to={linkItem.url}>{linkItem.label}</Link>
                  </li>
                ))}
              </ul>
              <p className="my-0">
                <span className="crwd-font mr-2">powered by</span>
                {parse(dataCR.html)}
              </p>
              <p className="my-0 text-xs">
                <span className="crwd-font mr-2">
                  © {new Date().getFullYear()}
                </span>
                {parse(dataCR.html)}
              </p>
            </div>

            <div className="col-12 md:col-4 footer-payment-systems justify-content-center md:justify-content-end">
              <FontAwesomeIcon icon={faCcVisa} />
              <FontAwesomeIcon icon={faCcMastercard} />
              <FontAwesomeIcon icon={faCcDiscover} />
              <FontAwesomeIcon icon={faCcAmex} />
              {/* TODO: Convert declared import to class list */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
